import React from 'react';
import PropTypes from 'prop-types';
import MenuBandageComponent from './MenuBandageComponent';
import LinkComponent from '../LinkComponent';

const MenuLinkComponent = ({
    faIcon,
    title,
    link,
    bandage,
}) => (
    <li>
        <LinkComponent to={link}>
            {faIcon ? <i className={`fa ${faIcon}`} /> : null}
            <span>{title}</span>
            {bandage ? (
                <MenuBandageComponent
                    title={bandage.title}
                    faIcon={bandage.faIcon}
                />
            ) : null}
        </LinkComponent>
    </li>
);

MenuLinkComponent.defaultProps = {
    bandage: {
        title: '',
        faIcon: '',
    },
    faIcon: '',
    link: null,
    title: '',
};

MenuLinkComponent.propTypes = {
    bandage: PropTypes.shape({
        faIcon: PropTypes.string,
        title: PropTypes.string,
    }),
    faIcon: PropTypes.string,
    link: PropTypes.string,
    title: PropTypes.string,
};

export default MenuLinkComponent;
